// routes
import { PATH_CONTACT_CENTER, PATH_ONLINE } from "./routes/paths";

// API
// ----------------------------------------------------------------------

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = PATH_ONLINE.accept;
export const PATH_AFTER_LOGIN_CC = PATH_CONTACT_CENTER.openingScript;
